import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem } from '@marriott/mi-ui-library-shop';

export const StyledSearchSummaryContainerDiv = styled.div`
  ${rtl`
  &.results-summary-container{
    width:${toRem(128)};
  }
  &.result-summary-de{
    min-width:${toRem(100)};
    line-height:${toRem(16)}
  }
  &.results-summary{
    display:flex;
    align-items:center;
    line-height:${toRem(24)};
  }
  
  /* Chat summary styles */
  .chat-summary-section {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    padding: 0;
  }
  
  .summary-content {
    display: flex;
    align-items: center;
    font-family: var(--typography-font-family, 'Swiss721 BT', sans-serif);
  }
  
  .results-count {
    font-size: ${toRem(14)};
    line-height: ${toRem(20)};
    font-weight: var(--typography-body-font-weight, 500);
    color: var(--color-set-brand-fg-color, var(--t-brand-fg-color, #1c1c1c));
  }
  
  /* Responsive adjustments */
  @media (max-width: 768px) {
    .results-count {
      font-size: ${toRem(12)};
      line-height: ${toRem(18)};
    }
    
    .chat-summary-section {
      padding: ${toRem(6)} 0;
    }
  }
  
  /* High contrast mode support */
  @media (prefers-contrast: high) {
    .results-count {
      color: var(--color-set-brand-fg-color, #000000);
    }
  }
  
  `}
`;
